import {
  loadScript,
  loadStyle,
} from '@trp-dms-digital-shared/ds-ui-library-common';

import { Constants, Defaults } from '../common/constants.js';
import type { IIDEpConfig } from '../../types.js';

declare global {
  interface Window {
    iidEpConfig: IIDEpConfig;
  }
}

export class Attestation {
  public generateAttestation(): void {
    const assetsDomain =
      window[Constants.POP_CONFIGURATION].assetsDomain ||
      Defaults.ASSETS_DOMAIN;

    window.iidEpConfig = {
      audience: 'tpd', // ide or tpd
      country: 'au', // country code for country specific content
      language: 'en', // language code for language specific content
    };

    loadStyle(`${assetsDomain}/entry-point/iid/style.css`);

    loadScript(
      `${assetsDomain}/entry-point/iid/lit-server.js`,
      true,
      true,
      'module',
    ).then(() => {
      const epElement: HTMLElement = document.createElement('iid-entry-points');
      document.body.appendChild(epElement);
      void 0;
    });
  }
}
